import React from 'react';
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from '@chakra-ui/button';

interface ButtonProps extends ChakraButtonProps {
  variant?: 'primary' | 'secondary';
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  ...props
}) => {
  const isPrimary = variant === 'primary';

  return (
    <ChakraButton
      px={3}
      fontSize="14px"
      color={isPrimary ? 'white' : 'gray.800'}
      background={isPrimary ? 'gray.900' : 'gray.300'}
      _hover={{
        bgColor: isPrimary ? 'black' : 'gray.500',
      }}
      {...props}
    >
      {children}
    </ChakraButton>
  );
};
